var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "loading-container-".concat(_vm.cssPrefix),
      staticStyle: { "min-height": "150px" },
    },
    [
      _c("div", { class: "loading-anim-wrapper-".concat(_vm.cssPrefix) }, [
        _c(
          "svg",
          {
            attrs: {
              id: "emxv99o7iw91",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              viewBox: "0 0 189 40",
              "shape-rendering": "geometricPrecision",
              "text-rendering": "geometricPrecision",
              width: "189",
              height: "40",
            },
          },
          [
            _c("g", { attrs: { id: "emxv99o7iw92" } }, [
              _c("polygon", {
                attrs: {
                  id: "emxv99o7iw93",
                  points: "181,23 181,15 173,15 181,3 181,11 189,11",
                  transform: "matrix(1 0 0 1 -2.57589999999999 6)",
                  fill: "rgb(73,219,201)",
                  "fill-rule": "evenodd",
                  stroke: "none",
                  "stroke-width": "1",
                },
              }),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "emxv99o7iw94_tr",
                    transform: "translate(147.001381,18.305599) rotate(45)",
                  },
                },
                [
                  _c("polygon", {
                    attrs: {
                      id: "emxv99o7iw94",
                      points:
                        "150.200000,12 155,16.800000 151.800000,20 147,15.200000 142.200000,20 139,16.800000 143.800000,12 139,7.200000 142.200000,4 147,8.800000 151.800000,4 155,7.200000",
                      transform:
                        "skewX(-0) skewY(0) scale(1.000004,1.000004) translate(-147,-12)",
                      fill: "rgb(251,162,112)",
                      "fill-rule": "evenodd",
                      stroke: "none",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "emxv99o7iw95_ts",
                    transform:
                      "translate(114,19.060400) scale(1.170000,1.170000)",
                  },
                },
                [
                  _c("circle", {
                    attrs: {
                      id: "emxv99o7iw95",
                      r: "8",
                      transform: "translate(0,0)",
                      fill: "rgb(238,62,160)",
                      "fill-rule": "evenodd",
                      stroke: "none",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("polygon", {
                attrs: {
                  id: "emxv99o7iw96",
                  points:
                    "88,10 88,14 82,14 82,20 78,20 78,14 72,14 72,10 78,10 78,4 82,4 82,10",
                  transform: "matrix(1 0 0 1 0 7)",
                  fill: "rgb(246,110,138)",
                  "fill-rule": "evenodd",
                  stroke: "none",
                  "stroke-width": "1",
                },
              }),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "emxv99o7iw97_to",
                    transform: "translate(45,16.997900)",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      id: "emxv99o7iw97",
                      d: "M53,8L37,8L37,18L41,18L41,16L49,16L49,18L53,18L53,8ZM55,6L55,8L55,18L55,20L47,20L47,18L43,18L43,20L35,20L35,18L35,8L35,6L37,6L44,6L44,4L44,2L49,2L49,0L51,0L51,2L51,4L46,4L46,6L53,6L55,6ZM47,10L47,12L47,14L51,14L51,12L51,10L47,10ZM39,10L43,10L43,12L43,14L39,14L39,12L39,10Z",
                      transform: "translate(-45,-10)",
                      fill: "rgb(255,196,96)",
                      "fill-rule": "evenodd",
                      stroke: "none",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "g",
                {
                  attrs: {
                    id: "emxv99o7iw98_to",
                    transform: "translate(10.500000,19.500000)",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      id: "emxv99o7iw98",
                      d: "M15.300000,17.107450C15.300000,17.576650,14.909850,17.957450,14.439800,17.957450C13.970600,17.957450,13.585550,17.576650,13.585550,17.107450C13.585550,16.638250,13.202200,16.257450,12.733000,16.257450C12.262950,16.257450,11.881300,16.809100,11.881300,17.279150C11.881300,17.748350,11.499650,18.300000,11.030450,18.300000L10.180450,18.300000C9.710400,18.300000,9.330450,17.748350,9.330450,17.279150C9.330450,16.809100,8.949650,16.343300,8.480450,16.343300C8.010400,16.343300,7.630450,16.852450,7.630450,17.321650C7.630450,17.790850,7.249650,18.300000,6.780450,18.300000L5.930450,18.300000C5.460400,18.300000,5.080450,17.748350,5.080450,17.279150C5.080450,16.809100,4.699650,16.343300,4.230450,16.343300C3.760400,16.343300,3.380450,16.680750,3.380450,17.149950C3.380450,17.620000,3.009850,17.978700,2.539800,17.978700C2.070600,17.978700,1.700000,17.576650,1.700000,17.107450L1.700000,11.375050C1.700000,7.739600,4.731100,4.700000,8.480450,4.700000C12.229800,4.700000,15.300000,7.739600,15.300000,11.375050L15.300000,17.107450ZM8.480450,3C3.785900,3,0,6.795250,0,11.375050L0,17.957450C0,18.896700,0.741200,20,1.680450,20L2.305200,20C2.781200,20,3.275050,19.676150,3.575100,19.308100C3.729800,19.117700,3.965250,18.911150,4.230450,18.911150C4.494800,18.911150,4.730250,19.161050,4.884950,19.350600C5.185850,19.718650,5.679700,20,6.154850,20L6.577300,20C7.046500,20,7.533550,19.679550,7.833600,19.318300C7.987450,19.133000,8.219500,18.928150,8.480450,18.928150C8.741400,18.928150,8.972600,19.175500,9.127300,19.361650C9.426500,19.722050,9.913550,20,10.382750,20L10.827300,20C11.296500,20,11.783550,19.679550,12.083600,19.318300C12.237450,19.133000,12.469500,18.928150,12.730450,18.928150C12.991400,18.928150,13.222600,19.175500,13.377300,19.361650C13.676500,19.722050,14.163550,20,14.632750,20L15.280450,20C16.218850,20,17,18.896700,17,17.957450L17,11.375050C17,6.795250,13.175000,3,8.480450,3L8.480450,3ZM11.050000,12.066667C10.580800,12.066667,10.200000,11.685017,10.200000,11.216667C10.200000,10.748317,10.580800,10.366667,11.050000,10.366667C11.518350,10.366667,11.900000,10.748317,11.900000,11.216667C11.900000,11.685017,11.518350,12.066667,11.050000,12.066667L11.050000,12.066667ZM11.050000,8.666667C9.641550,8.666667,8.500000,9.808217,8.500000,11.216667C8.500000,12.625117,9.641550,13.766667,11.050000,13.766667C12.458450,13.766667,13.600000,12.625117,13.600000,11.216667C13.600000,9.808217,12.458450,8.666667,11.050000,8.666667L11.050000,8.666667ZM5.950000,12.066667C5.480800,12.066667,5.100000,11.685017,5.100000,11.216667C5.100000,10.748317,5.480800,10.366667,5.950000,10.366667C6.418350,10.366667,6.800000,10.748317,6.800000,11.216667C6.800000,11.685017,6.418350,12.066667,5.950000,12.066667L5.950000,12.066667ZM5.950000,8.666667C4.541550,8.666667,3.400000,9.808217,3.400000,11.216667C3.400000,12.625117,4.541550,13.766667,5.950000,13.766667C7.358450,13.766667,8.500000,12.625117,8.500000,11.216667C8.500000,9.808217,7.358450,8.666667,5.950000,8.666667L5.950000,8.666667Z",
                      transform: "translate(-8.500000,-11.500000)",
                      fill: "rgb(253,110,190)",
                      stroke: "none",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "loading-title" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "...\n    "),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }